import * as Types from '../../api';

import { gql } from '@apollo/client';
import * as Apollo from '@apollo/client';
const defaultOptions = {} as const;
export type DeleteMediaMutationVariables = Types.Exact<{
  id: Types.Scalars['Int']['input'];
}>;


export type DeleteMediaMutation = { __typename?: 'Mutation', deleteMedia: { __typename?: 'MutationResult', errors?: Array<{ __typename?: 'Error', location: Array<string>, type: string, context?: string | null }> | null } };

export type UpdateMediaMutationVariables = Types.Exact<{
  id: Types.Scalars['Int']['input'];
  description?: Types.InputMaybe<Types.Scalars['String']['input']>;
  file?: Types.InputMaybe<Types.Scalars['Upload']['input']>;
}>;


export type UpdateMediaMutation = { __typename?: 'Mutation', updateMedia?: { __typename?: 'MutationResult', errors?: Array<{ __typename?: 'Error', location: Array<string>, type: string, context?: string | null }> | null } | null };

export type AddMediaMutationVariables = Types.Exact<{
  domainId: Types.Scalars['Int']['input'];
  description: Types.Scalars['String']['input'];
  file: Types.Scalars['Upload']['input'];
}>;


export type AddMediaMutation = { __typename?: 'Mutation', addMedia?: { __typename?: 'SaveResult', errors?: Array<{ __typename?: 'Error', location: Array<string>, type: string, context?: string | null }> | null } | null };


export const DeleteMediaDocument = gql`
    mutation DeleteMedia($id: Int!) {
  deleteMedia(id: $id) {
    errors {
      location
      type
      context
    }
  }
}
    `;
export type DeleteMediaMutationFn = Apollo.MutationFunction<DeleteMediaMutation, DeleteMediaMutationVariables>;

/**
 * __useDeleteMediaMutation__
 *
 * To run a mutation, you first call `useDeleteMediaMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteMediaMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteMediaMutation, { data, loading, error }] = useDeleteMediaMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useDeleteMediaMutation(baseOptions?: Apollo.MutationHookOptions<DeleteMediaMutation, DeleteMediaMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DeleteMediaMutation, DeleteMediaMutationVariables>(DeleteMediaDocument, options);
      }
export type DeleteMediaMutationHookResult = ReturnType<typeof useDeleteMediaMutation>;
export type DeleteMediaMutationResult = Apollo.MutationResult<DeleteMediaMutation>;
export type DeleteMediaMutationOptions = Apollo.BaseMutationOptions<DeleteMediaMutation, DeleteMediaMutationVariables>;
export const UpdateMediaDocument = gql`
    mutation UpdateMedia($id: Int!, $description: String, $file: Upload) {
  updateMedia(id: $id, description: $description, file: $file) {
    errors {
      location
      type
      context
    }
  }
}
    `;
export type UpdateMediaMutationFn = Apollo.MutationFunction<UpdateMediaMutation, UpdateMediaMutationVariables>;

/**
 * __useUpdateMediaMutation__
 *
 * To run a mutation, you first call `useUpdateMediaMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateMediaMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateMediaMutation, { data, loading, error }] = useUpdateMediaMutation({
 *   variables: {
 *      id: // value for 'id'
 *      description: // value for 'description'
 *      file: // value for 'file'
 *   },
 * });
 */
export function useUpdateMediaMutation(baseOptions?: Apollo.MutationHookOptions<UpdateMediaMutation, UpdateMediaMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateMediaMutation, UpdateMediaMutationVariables>(UpdateMediaDocument, options);
      }
export type UpdateMediaMutationHookResult = ReturnType<typeof useUpdateMediaMutation>;
export type UpdateMediaMutationResult = Apollo.MutationResult<UpdateMediaMutation>;
export type UpdateMediaMutationOptions = Apollo.BaseMutationOptions<UpdateMediaMutation, UpdateMediaMutationVariables>;
export const AddMediaDocument = gql`
    mutation AddMedia($domainId: Int!, $description: String!, $file: Upload!) {
  addMedia(domainId: $domainId, description: $description, file: $file) {
    errors {
      location
      type
      context
    }
  }
}
    `;
export type AddMediaMutationFn = Apollo.MutationFunction<AddMediaMutation, AddMediaMutationVariables>;

/**
 * __useAddMediaMutation__
 *
 * To run a mutation, you first call `useAddMediaMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAddMediaMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [addMediaMutation, { data, loading, error }] = useAddMediaMutation({
 *   variables: {
 *      domainId: // value for 'domainId'
 *      description: // value for 'description'
 *      file: // value for 'file'
 *   },
 * });
 */
export function useAddMediaMutation(baseOptions?: Apollo.MutationHookOptions<AddMediaMutation, AddMediaMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<AddMediaMutation, AddMediaMutationVariables>(AddMediaDocument, options);
      }
export type AddMediaMutationHookResult = ReturnType<typeof useAddMediaMutation>;
export type AddMediaMutationResult = Apollo.MutationResult<AddMediaMutation>;
export type AddMediaMutationOptions = Apollo.BaseMutationOptions<AddMediaMutation, AddMediaMutationVariables>;